import emailjs from "@emailjs/browser"

const emailjsConfig = () => {
    emailjs.init({
        publicKey: "45q9_sOUAyc3UYhNO",
    });
};

export default emailjsConfig